// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kNqw","colBig":"styles_colBig__CgUFJ","colSmall":"styles_colSmall__3z9PH","shopifyNameWrapper":"styles_shopifyNameWrapper__1P_NM"};